import HttpService from "./http.service";

/**
 * Backend API service.
 * Uses current session token for Authorization
 */
export default class ApiService extends HttpService {
    /**
     * Getter base API url
     * @returns {string}
     */
    get baseURL() {
        return this.config.baseURL || '';
    }

    /**
     * Create new request with session token by default
     * @param [config] {Object}
     * @returns {HttpRequest}
     */
    create(config) {
        return super
            .create(config)
            .withToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI3IiwianRpIjoiZGQ2OGUyOTVkNTBjNDMyOTliZTE3ZDBiMGFiZDFiZTNmYWU0Mjc5ZjY1OGFkYzkxYjA1MWJlNzk0MTg4OWRkMzhkOWFlZGE3ZWQ3YTJhMGIiLCJpYXQiOjE1OTM1MjY1MjIsIm5iZiI6MTU5MzUyNjUyMiwiZXhwIjoxNTkzOTU4NTIyLCJzdWIiOiI0MyIsInNjb3BlcyI6W119.hcjknFFPEd13pw0WsnW24XyTwjNLFDHQK_br3C-FZOn-g549SFIlLeQgSUt_rhj4t7HNaJhYklQv_BAZjyvgOqtrbdMrWJc3VLcUmMr8k3tKs1PukYWTl3vd-ki62JhF8XtZvn88e7REBHXj4NFkTrP7kzSlJXIq17ytWbhrw8d8w1DNWhPtSKWgbpT-Bbk54Ux2yQ1M_YCDsOdpZ3kk_Rwr9jPTDIeTrbprnoh7-QrvBlP8CUNVI19T6CFdrq5upPdUnGdB2aSzEwN674AIj3OSDEe2pwk7nO5Ns9HHcRLoWnZhlxumuD05FrT6L0pDR6J9ubekPvs0g5smeyFUcW3fxT1NrB8w5PmN49WH4bZxINt6qeT1r1XhS_fg9DS6LDE1zuiNzsIGDGgthGiASwTfAYQo0KuaOkq-S_NgqxLT8LtyryGHX235o6-C9IURo2KiW8_1DS8mABSCA4dZFucup3FuPof-O2yI8WgpwwPpwNtMwhRlOgLg5Ex5sy-yT41jATh5pHfQhtOoJ_Gw5_w0mgxPFsC7S445p4vyedK_sblL5LT_ENdAdGxO_h_lOmbMX7FiHFOK0ztjhk3PjXhm8e1uWnHnnitQ8mkMm6pXmEv2ZjX8cAGghPt9klmz-MT_Bify8fF5NSvE_VIn__Nqc2nG3WBrkvRswXNtVxU');
    }
}
